import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "AlertModal_Overlay"
}
const _hoisted_2 = { class: "AlertModal_OkLink" }

import { ICustomAlertDetails } from '@/stores/useSaleStore';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isVisible = ref(false);
const currentAlert = ref<ICustomAlertDetails>();
watch(currentAlert, a => {
  console.log('Custom alert', a)
  if (a) {
    isVisible.value = true;
  }
})

// @ts-ignore
window.addEventListener('customalert', (e: CustomEvent) => {
  if (e.detail) {
    const d = e.detail as unknown as ICustomAlertDetails;
    currentAlert.value = d;
  }
})

return (_ctx: any,_cache: any) => {
  return (isVisible.value && currentAlert.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass({
    AlertModal: true,
    AlertModal__Success: currentAlert.value.type === 'success',
    AlertModal__Error: currentAlert.value.type === 'error',
  })
        }, [
          _createElementVNode("h2", null, _toDisplayString(currentAlert.value.title), 1),
          _createElementVNode("p", null, _toDisplayString(currentAlert.value.message), 1),
          _createElementVNode("p", _hoisted_2, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isVisible.value = false))
            }, "OK")
          ])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})